import React from 'react';
export default function Cafecito() {
  return <aside className="support-banner">
        <div><span className="eyebrow">LECTURAS QUE NOS ENCUENTRAN</span><h2>La cultura se hace entre todos.</h2><p>Tu aporte acompaña a Boca de Sapo. Gracias por ser parte.</p></div>
        <a className="button button-accent" href="https://cafecito.app/bocadesapo" target="_blank" rel="noopener noreferrer">Invitanos un café <span aria-hidden="true">↗</span></a>
    </aside>;
}
